import { urlBuilder } from '../mappers';
import { PATHS } from '../constants';
import type { TransformedCmsConfigItem, ExtendedTransformedCmsConfigItem } from '../types';

export const configuredMenuItemTransformer = ({
    id,
    type,
    urlParams,
    alias,
    badge,
    ...rest
}: TransformedCmsConfigItem): ExtendedTransformedCmsConfigItem => ({
    ...rest,
    id,
    type,
    badge,
    url: urlBuilder[type] ? urlBuilder[type]({ ...urlParams }) : PATHS.ROOT,
    displayName: alias,
});
